import { Component, OnInit } from '@angular/core';
import { BaseConfig } from 'src/app/services/base-config.service';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { MwsService } from 'src/app/services/mws-service.service';
import { UserCache } from 'src/app/services/user-cache';

@Component({
  selector: 'app-mws-setting',
  templateUrl: './mws-setting.component.html',
  styleUrls: ['./mws-setting.component.css']
})
export class MwsSettingComponent implements OnInit {

  constructor(
    private clinicData:ClinicDataService,
    private mwsService:MwsService
  ) { }

  ngOnInit() {
  }
  async setting(){
    await this.mwsService.setting();
  }
  
}
